import React, { Component } from 'react';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { connect } from 'react-redux';

import * as urls from './urls';

import { TextInput, DatetimeInput } from 'components/input'
import DisabledInput from "components/input/DisabledInput";
import { InputOptions } from 'util/constants';


class AppSubscriptionAdjustBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const expiry = new Date(record['expiry_time'].replace(/[^0-9a-zA-Z-: ]/g, ''));
    expiry.setHours(23);
    expiry.setMinutes(59);
    expiry.setSeconds(59);

    const update_data = {
      shop_id: record['shop_id'],
      expiry: parseInt(expiry.getTime() / 1000, 10),
      note: record['note'],
    };

    props.crudUpdate(props.resource, props.id, update_data, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        {...this.props}
        editBackendPath={urls.appSubscriptionAdjustBackendPath}
        updateDataOnMount={false}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm>
          <DisabledInput
            source='shop_id'
            label='Shop ID'
            isRequired={true}
          />
          <DisabledInput
            source='shop_name'
            label='Shop Name'
            force_value={this.props.formInitial.shop_name || '-'}
          />
          <DisabledInput
            source='current_expiry_time'
            label='Delivery Time'
            force_value={this.props.formInitial.expiry_time || '-'}
          />
          <DatetimeInput
            source='expiry_time'
            label='New Expiry Time'
            isRequired={true}
            options={InputOptions}
          />
          <TextInput
            source='note'
            label='Note'
            options={InputOptions}
          />
        </SimpleForm>
      </Edit>
    )
  }
}

export const AppSubscriptionAdjust = connect(
  (state) => ({
    formValues: ((state.form['record-form'] || {}).values || {}),
    formInitial: ((state.form['record-form'] || {}).initial || {}),
  }),
  {}
)(AppSubscriptionAdjustBase);



// WEBPACK FOOTER //
// ./src/routes/product/AppSubscriptionAdjust.js